/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './like.defs.js'
export * as $defs from './like.defs.js'
